module.exports = __webpack_public_path__ + "static/media/ni.7c10d0c7.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/ni.svg
// module id = 2175
// module chunks = 0